import { useContext, useEffect, useState } from "react";
import { IonSpinner } from "@ionic/react";
import { showToaster } from "../../../../global/context/action/toaster/toaster";

import { GlobalContext } from "../../../../global/context/Provider";
import { regexEmail } from "../../../../global/utils/expresionesRegulares";
import {
  resetEnviarMail,
  wsPostEnviarMailInforme,
  wsPostEnviarMailLaboratorio,
} from "../../../context/Actions/enviarMail/enviarMail";
import { hideModal } from "../../../context/Actions/modal/modal";
import { PortalContext } from "../../../context/Provider";
import InputV1 from "../InputV1/InputV1";

import "./EnviarMailModal.css";
const EnviarMailModal = ({
  paciente,
  idProtocolo,
  idturno,
  tipo,
  estudio,
  codigo,
}) => {
  const {
    modalDispatch,
    enviarMailState,
    enviarMailDispatch,
    selectDropDownState,
  } = useContext(PortalContext);

  const { toasterDispatch } = useContext(GlobalContext);
  const [checkError, setCheckError] = useState(false);
  const [laboratorioDto, setLaboratorioDto] = useState({
    email: paciente.email,
    idProtocolo: idProtocolo,
  });
  const [informeDto, setInformeDto] = useState({
    idturno: idturno,
    idArchivoReemplazo: -1,
    nombreArchivo: "",
    email: paciente.email,
    tipo: tipo,
    codigo: codigo,
    estudio: estudio,
  });

  const onChangeInput = (e) => {
    setCheckError(isErrorEmail(e.target.value));
    if (laboratorioDto.idProtocolo > 0) {
      setLaboratorioDto({ ...laboratorioDto, [e.target.name]: e.target.value });
    } else {
      setInformeDto({ ...informeDto, [e.target.name]: e.target.value });
    }
  };

  const isErrorEmail = (email) => {
    if (!regexEmail.test(email)) {
      return true;
    }
    if (email === "") {
      return true;
    }
    return false;
  };

  const enviarMail = () => {
    const { pacienteElegido } = selectDropDownState.selectDropDown.selectGlobal;
    if (!checkError) {
      if (laboratorioDto.email !== "" && laboratorioDto.idProtocolo > 0) {
        laboratorioDto.idPacFamiliar = pacienteElegido
          ? pacienteElegido.id
          : -1;
        wsPostEnviarMailLaboratorio(
          laboratorioDto,
          pacienteElegido ? pacienteElegido.id : -1
        )(enviarMailDispatch);
      } else {
        informeDto.idPacFamiliar = pacienteElegido ? pacienteElegido.id : -1;
        wsPostEnviarMailInforme(
          informeDto,
          pacienteElegido ? pacienteElegido.id : -1
        )(enviarMailDispatch);
      }
    } else {
      showToaster(
        {
          texto: "Ingrese un e-mail válido",
          tipo: "danger",
        },
        "centroArriba"
      )(toasterDispatch);
    }
  };

  useEffect(() => {
    if (enviarMailState.enviarMail.data === 200) {
      showToaster(
        {
          texto: "E-mail enviado correctamente",
          tipo: "success",
        },
        "centroArriba"
      )(toasterDispatch);
      resetEnviarMail()(enviarMailDispatch);
      dismiss();
    }

    //eslint-disable-next-line
  }, [enviarMailState.enviarMail.data]);

  useEffect(() => {
    if (
      enviarMailState.enviarMail.error !== null &&
      enviarMailState.enviarMail.error !== false &&
      enviarMailState.enviarMail.error !== undefined
    ) {
      const error = enviarMailState.enviarMail.error;

      // Determinar mensaje a mostrar con fallback robusto
      let mensajeError;
      let tipoToaster = "danger";

      if (
        error.type === "VALIDATION_ERROR" &&
        error.validationErrors?.length > 0
      ) {
        mensajeError = error.validationErrors[0].message;
        tipoToaster = "warning";
      } else {
        // Manejar tanto strings como objetos legacy
        mensajeError =
          typeof error.detail === "string"
            ? error.detail
            : error.detail?.detail || "No se pudo enviar el email";
      }

      if (mensajeError) {
        showToaster(
          {
            texto: mensajeError,
            tipo: tipoToaster,
          },
          "centroArriba"
        )(toasterDispatch);
        resetEnviarMail()(enviarMailDispatch);
        dismiss();
      }
    }
    //eslint-disable-next-line
  }, [enviarMailState.enviarMail.error]);

  const dismiss = () => {
    hideModal()(modalDispatch);
  };

  return (
    <div className="ptur-enviarMailModal-container">
      <div className="ptur-enviarMailModal-header bgcG-latex30">
        <span className="c-white rb18m">Enviar informe por e-mail</span>
      </div>
      <div className="ptur-enviarMailModal-body">
        <div className="ptur-enviarMailModal-txt">
          <span className="rb16b">Envia tu informe via Email.</span>
        </div>
        <div className="ptur-enviarMailModal-input">
          <InputV1
            inputType="text"
            headerStr={"Email"}
            errorStr={"El email es requerido"}
            onChange={onChangeInput}
            checkError={checkError}
            isRequired={true}
            name="email"
            value={
              laboratorioDto.idProtocolo > 0
                ? laboratorioDto.email
                : informeDto.email
            }
          />
        </div>
        <div
          className="ptur-enviarMailModal-botones"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <button
            onClick={() => dismiss()}
            className="btn bgc-latex30 c-white rb18m"
            disabled={enviarMailState.enviarMail.loading}
          >
            Cancelar
          </button>
          <button
            onClick={enviarMail}
            className="btn bgc-primary c-white rb18m"
            disabled={enviarMailState.enviarMail.loading}
            style={{
              minHeight: "40px",
              ...(enviarMailState.enviarMail.loading && {
                paddingTop: 7,
                paddingBottom: 6,
              }),
            }}
          >
            {enviarMailState.enviarMail.loading ? (
              <IonSpinner name="lines-small" />
            ) : (
              "Enviar"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default EnviarMailModal;
